import React from 'react';
import connect from 'react-redux/lib/connect/connect';
import { isMobilePage } from '../common/cores';
import { resource_url } from '../common/cores/keys';

const Check = (props) => {
    const { checkData } = props;
    // const loading = false;
    // const loading = true;
    // console.log(props);
    return (
        <div data-v-623d66c4="" className="loading-back" style={{ display: checkData.check ? "flex" : "none" }}>
            {/* <i data-v-e56d064c="" data-v-ee85aa0c="" className="fa-lg fa-regular fa-spinner rotate"  style={{margin: "auto"}}></i> */}
            {/* <span>{checkData.title}</span> */}
            { checkData.check && <img className=" " src={`${resource_url}/images/check/${ !isMobilePage() ? checkData.pc_imagename : checkData.mobile_imagename }`} alt=""/>}
        </div>
    );
};

const mapStateToProps = state =>({
    checkData: state.page.checkData
});

export default connect( mapStateToProps )(Check);


// WEBPACK FOOTER //
// ./src/containers/Check.js